export default {
  playlists: state => state.playlists,
  playlistsArray: state =>
    state.playlists
      ? Object.keys(state.playlists).map(key => state.playlists[key])
      : []
};
